import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import PayHeader from '../components/pay/payHeader';
import Free from '../components/pay/free';
import Standard from '../components/pay/standard';
import Premium from '../components/pay/premium';
import PriceTable from '../components/pay/PriceTable';
import Payment from '../../service/pay/pay';
import Menu from '../components/menu/Menu';
import { useModal } from '../../context/ModalContext';
import MembershipDetail from '../components/pay/MembershipDetail';

interface MembershipPlan {
  type: string;
  plan_id: number;
  plan_name: string;
  plan_prc: number;
  is_discount: string;
}

const standardData = [
  {
    month: 1,
    data: {
      type: 'S',
      plan_id: 6,
      plan_name: '전국 얼리버드 특전',
      plan_prc: 70000,
      is_discount: 'Y',
      name: '전국 1개월 스탠다드 멤버십 얼리버드',
    },
  },
  {
    month: 3,
    data: {
      type: 'S',
      plan_id: 7,
      plan_name: '전국 얼리버드 특전',
      plan_prc: 190000,
      is_discount: 'Y',
      name: '전국 3개월 스탠다드 멤버십 얼리버드',
    },
  },
  {
    month: 6,
    data: {
      type: 'S',
      plan_id: 8,
      plan_name: '전국 얼리버드 특전',
      plan_prc: 340000,
      is_discount: 'Y',
      name: '전국 6개월 스탠다드 멤버십 얼리버드',
    },
  },
  {
    month: 12,
    data: {
      type: 'S',
      plan_id: 9,
      plan_name: '전국 얼리버드 특전',
      plan_prc: 600000,
      is_discount: 'Y',
      name: '전국 12개월 스탠다드 멤버십 얼리버드',
    },
  },
];

const PaymentPlan = () => {
  const server = new URL(
    process.env.REACT_APP_HOST_API || 'http://localhost:3333/',
  ).origin;

  const [openMenu, setOpenMenu] = useState(false);
  const [standardPlans, setStandardPlans] = useState<MembershipPlan[]>([]);
  const [premiumPlans, setPremiumPlans] = useState<MembershipPlan[]>([]);
  const [standardPricePlans, setStandardPricePlans] = useState<
    MembershipPlan[]
  >([]);
  const [premiumPricePlans, setPremiumPricePlans] = useState<MembershipPlan[]>(
    [],
  );
  const [selectedMonth, setSelectedMonth] = useState(12);
  const [selectedPriceMonth, setselectedPriceMonth] = useState(12);
  const monthList = [1, 3, 6, 12];
  const membershipList = ['Standard', 'Premium'] as const;

  const [selectedMembership, setSelectedMembership] = useState<
    'Standard' | 'Premium'
  >('Standard');

  const [discountPlan, setDiscountPlan] = useState<MembershipPlan | undefined>(
    standardData.find((item) => item.month === selectedMonth)?.data,
  );

  const handleMembershipClick = (
    membership: (typeof membershipList)[number],
  ) => {
    setSelectedMembership(membership);
  };

  const handleMonthClick = (month: number) => {
    setSelectedMonth(month);
  };

  const handlePriceMonthClick = (month: number) => {
    setselectedPriceMonth(month);
  };

  const getMembershipPlan = async (month: number) => {
    try {
      const res = await Payment.membershipPlan(month);
      setStandardPlans(res.data.standard || []);
      setPremiumPlans(res.data.premium || []);
    } catch (error) {
      alert('상품 목록을 불러오는 데 실패했습니다.');
    }
  };

  const getMembershipPricePlan = async (month: number) => {
    try {
      const res = await Payment.membershipPlan(month);
      console.group(res.data);

      setStandardPricePlans(res.data.standard || []);
      setPremiumPricePlans(res.data.premium || []);
    } catch (error) {
      alert('가격 비교 상품 목록을 불러오는 데 실패했습니다.');
    }
  };

  useEffect(() => {
    getMembershipPricePlan(selectedPriceMonth);
  }, [selectedPriceMonth]);

  useEffect(() => {
    getMembershipPlan(selectedMonth);
  }, [selectedMonth]);

  useEffect(() => {
    const newDiscountPlan = standardData.find(
      (item) => item.month === selectedMonth,
    )?.data;
    setDiscountPlan(newDiscountPlan);
  }, [selectedMonth]);

  // const { modal, modalDispatch } = useModal();

  // useEffect(() => {
  //   if (!modal.membership) {
  //     modalDispatch({ type: 'M' });
  //   }
  // }, []);

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <PayHeader setOpenMenu={setOpenMenu} menu={true} />
      <Content>
        <div>
          <Top>
            <TitleBox>
              <PageTitle>땅집고옥션 멤버십 요금제</PageTitle>
            </TitleBox>
            <Description>
              지금 바로 구독하고 멤버십 회원에게만 제공되는
              <br />
              특별한 서비스를 누려보세요.
            </Description>
          </Top>
          <TitleBox>
            {/* <Early>
              ※ 얼리버드 특전 구매는 25년 5월 중 가능합니다. <br />
              구매한 얼리버드 상품은 25년 6월 1일부터 사용 가능합니다.
            </Early> */}
            <Option>
              {monthList.map((month) => (
                <OptionButton
                  key={month}
                  selected={selectedMonth === month}
                  onClick={() => handleMonthClick(month)}
                >
                  {month}개월
                </OptionButton>
              ))}
            </Option>

            <Membership>
              <Free />
              {standardPlans.length > 0 && (
                <Standard
                  plans={standardPlans}
                  month={selectedMonth}
                  discountPlan={discountPlan}
                />
              )}
              {selectedMonth === 12 && premiumPlans.length > 0 && (
                <Premium plans={premiumPlans} month={selectedMonth} />
              )}
            </Membership>
          </TitleBox>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <TitleBox>
            <PageTitle style={{ marginBottom: '18px' }}>
              멤버십 요금 비교
            </PageTitle>
          </TitleBox>
          <Option>
            {monthList.map((month) => (
              <OptionButton
                key={month}
                selected={selectedPriceMonth === month}
                onClick={() => handlePriceMonthClick(month)}
              >
                {month}개월
              </OptionButton>
            ))}
          </Option>
          <PriceTable
            standardPlans={standardPricePlans}
            premiumPlans={premiumPricePlans}
          />
        </div>

        <div>
          <TitleBox>
            <PageTitle style={{ marginBottom: '42px' }}>
              멤버십 상세 비교
            </PageTitle>
          </TitleBox>
          <Option>
            {membershipList.map((membership, idx) => (
              <OptionButton
                key={idx}
                selected={selectedMembership === membership}
                onClick={() => handleMembershipClick(membership)}
              >
                {membership}
              </OptionButton>
            ))}
          </Option>

          <MembershipDetail selectedMembership={selectedMembership} />
        </div>
      </Content>
      <Footer />
      {openMenu && <Menu page="payment/plan" setOpenMenu={setOpenMenu} />}
    </div>
  );
};

export default PaymentPlan;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px 16px 72px;
  overflow-x: hidden;
  gap: 100px;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 42px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const PageTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 28px;
  font-weight: 700;
  line-height: 34.8px;
  color: #222222;
  text-align: center;
`;

const Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #616161;
`;

const Option = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Membership = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const OptionButton = styled.div<{ selected: boolean }>`
  width: 50%;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#008AFF' : '#f7f7f8;')};
  color: ${({ selected }) => (selected ? '#fff' : '#616161')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Early = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: #008aff;
  padding: 8px 16px;
  background-color: #e8f1ff;
  text-align: center;
  border-radius: 8px;
`;
